import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, FormControl, InputBase } from '@mui/material';
import { styled } from '@mui/system';

const StyledInput = styled(InputBase)(() => ({
    '& .MuiInputBase-input': {
        textAlign: 'right',
        color: 'white',
        padding: 0,
        lineHeight: '1rem',
        height: '100%',
    },
}));

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const handleChange = (event) => {
        i18n.changeLanguage(event.target.value);
    };

    return (
        <FormControl
            variant="outlined"
            size="small"
            sx={{
                m: 0,
                p: 0,
                minWidth: 50,
                height: 32,
                display: 'flex',
                alignItems: 'flex-end',  // Alinha o Select no fundo do FormControl
                justifyContent: 'flex-end',
            }}
        >
            <Select
                value={i18n.language}
                onChange={handleChange}
                input={<StyledInput />}
                sx={{
                    marginBottom: "4px",
                    padding: 0,
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-end',
                    '& .MuiSelect-select': {
                        padding: 0,
                        display: 'flex',
                        alignItems: 'flex-end',
                    },
                    '& .MuiSelect-icon': {
                        color: 'white',
                    },
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            bgcolor: 'white',
                            color: 'black',
                        },
                    },
                }}
            >
                <MenuItem value="pt" sx={{ color: 'black' }}>PT</MenuItem>
                <MenuItem value="en" sx={{ color: 'black' }}>EN</MenuItem>
                <MenuItem value="zh" sx={{ color: 'black' }}>中文</MenuItem>
            </Select>
        </FormControl>
    );
};


export default LanguageSwitcher;
